import { t } from "i18next";
import { Controller } from "react-hook-form";
import { Input } from "ui";

import { StaffManagerFormAtomProps } from "../StaffManagerForm.types";

import styles from "../StaffManagerForm.module.scss";

const PasswordFields = ({ control }: StaffManagerFormAtomProps) => {
  return (
    <div className={styles.form_twoInputsBlock}>
      <Controller
        control={control}
        name="password"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("Password")}
            placeholder={t("Enter Password")}
            isPassword
            errorMessage={error?.message}
            data-testid="staff-manager--password"
          />
        )}
      />

      <Controller
        control={control}
        name="repeatPassword"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("Repeat Password")}
            placeholder={t("Enter Password")}
            isPassword
            errorMessage={error?.message}
            data-testid="staff-manager--repeatPassword"
          />
        )}
      />
    </div>
  );
};
export default PasswordFields;
